import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "card",
  style: {"width":"28rem"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "card-title" }

interface Props {
    name: string;
    thumbnail?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Card',
  props: {
    name: {},
    thumbnail: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {



// Define emits with their types
const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.thumbnail)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.thumbnail,
          class: "card-img-top",
          alt: "Thumbnail"
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.name), 1),
      _cache[1] || (_cache[1] = _createElementVNode("p", { class: "card-text" }, "Click below to view data for this question.", -1)),
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
      }, "View Data")
    ])
  ]))
}
}

})